import aprilLogo from "components/Dashboard/ssApril@3x.png";

export const getTenantId = () => {
  const tenantId = process.env.REACT_APP_TENANT_ID;
  if (tenantId) {
    return tenantId;
  }
  const domain = window.location.hostname;
  if (domain.startsWith("olive") || domain.startsWith("jordan")) {
    return "olive";
  }
  if (domain.startsWith("pal.")) {
    return "pal";
  }
  return "april";
};

export const getTenantDetail = () => {
  const tenantId = getTenantId();
  const oliveDetails = {
    title: "Bond",
    logo: null,
    favIcon: "/favicon-olive.ico",
    className: "olive",
  };
  const aprilDetails = {
    title: "April Accessories",
    logo: aprilLogo,
    favIcon: "/favicon.ico",
    className: "april",
  };
  const palDetails = {
    title: "Olive",
    logo: null,
    favIcon: "/favicon.ico",
    className: "pal",
  };
  if (tenantId === "pal") {
    return palDetails;
  }
  if (tenantId === "olive") {
    return oliveDetails;
  }
  return aprilDetails;
};
